<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索记录..."
          @on-change="searchReceive"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        ></Input>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="15"
          @on-change="loadSalesPlanVol"
          show-total
          simple
          style="margin-right: 24px"
        />
      </div>
    </div>
    <h2 class="date">{{ curYear }}年{{ curMonth }}月</h2>
    <div class="table-wrapper" ref="tableWrapper">
      <Table :columns="columns" :data="salesStatVol" :height="tableHeight">
        <template slot-scope="{ row }" slot="vol">
          <div v-if="volIndexFile !== row._id" @click="show(row, 'transPrice')">
            <div>
              {{
                row.salesStat
                  ? row.salesStat.estSalesVolume
                    ? row.salesStat.estSalesVolume
                    : "-"
                  : "-"
              }}
            </div>
          </div>
          <div v-show="volFile === row._id">
            <Input
              style="width: 100px"
              autofocus
              @on-blur="setVol(row)"
              v-model="editVol"
            />
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";

import dayjs from "dayjs";

export default {
  name: "EditSalesPlan",
  components: {},
  data() {
    return {
      page: 0,
      tableHeight: 300,
      searchText: null,
      tableLoading: false,
      volIndexFile: null,
      volFile: null,
      editVol: null,
      columns: [
        {
          title: "销售项目",
          key: "sales",
          render: (h, params) => h("span", params.row.abbr),
        },
        {
          title: "计划销量",
          key: "date",
          align: "right",
          slot: "vol",
          minWidth: 100,
        },
        {
          title: "实际销量",
          key: "date",
          align: "right",
          render: (h, params) => h("span", ""),
        },
        {
          title: "完成率",
          key: "date",
          align: "right",
          render: (h, params) => h("span", ""),
        },
      ],
      curYear: null,
      curMonth: null,
    };
  },
  computed: {
    ...mapState({
      totalRows: (state) => state.receive.totalCounts,
      salesStatVol: (state) => state.salesStat.salesStatVol,
    }),
  },
  methods: {
    ...mapActions({
      getSalesStatVol: "salesStat/getSalesStatVolAction",
      postSalesStatVol: "salesStat/postSalesStatVolAction",
    }),
    async loadSalesPlanVol(page) {
      try {
        let api = {
          skip: this.page * 15,
          limit: 15,
        };
        api.year = this.$route.query.year;
        api.month = this.$route.query.month;
        // this.tableLoading = true;
        await this.getSalesStatVol(api);
        // this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        // this.tableLoading = false;
      }
    },
    // 切换数据与input的显示
    show(row) {
      this.volIndexFile = row._id;
      this.volFile = row._id;
      this.editVol = row.salesForecast;
    },
    // 失焦时保存数据
    async setVol(row) {
      this.volIndexFile = null;
      this.volFile = null;
      let api = {
        year: Number(this.curYear),
        month: Number(this.curMonth),
        sales: row._id,
      };
      if (this.editVol) {
        api.estSalesVolume = Number(this.editVol);
        await this.postSalesStatVol(api);
      }
    },
    searchReceive() {},
  },
  created() {
    this.curYear = this.$route.query.year;
    this.curMonth = this.$route.query.month;
    this.loadSalesPlanVol();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>